module.exports = __webpack_public_path__ + "e9baf4b505eb54129f832556ea16538e.svg";